const webApp = window.Telegram?.WebApp

export function initTelegram(): void {
  webApp?.ready()
  webApp?.expand()
  webApp?.disableVerticalSwipes?.()
  applyTheme(webApp?.colorScheme)
  webApp?.onEvent?.('themeChanged', () => applyTheme(window.Telegram?.WebApp.colorScheme))
  applyInsets()
  webApp?.onEvent?.('viewportChanged', applyInsets)
}

function applyTheme(scheme: 'light' | 'dark' | undefined): void {
  document.documentElement.classList.toggle('dark', scheme === 'dark')
}

function applyInsets(): void {
  const style = document.documentElement.style
  const app = window.Telegram?.WebApp as unknown as {
    safeAreaInset?: { top: number; bottom: number }
    contentSafeAreaInset?: { top: number; bottom: number }
  }

  style.setProperty('--tg-safe-area-inset-top', `${app?.safeAreaInset?.top ?? 0}px`)
  style.setProperty('--tg-safe-area-inset-bottom', `${app?.safeAreaInset?.bottom ?? 0}px`)
  style.setProperty('--tg-content-safe-area-inset-top', `${app?.contentSafeAreaInset?.top ?? 0}px`)
  style.setProperty(
    '--tg-content-safe-area-inset-bottom',
    `${app?.contentSafeAreaInset?.bottom ?? 0}px`,
  )
}

export function initData(): string {
  return webApp?.initData ?? ''
}

type TelegramLinks = {
  openLink?(url: string): void
}

export function openLink(url: string): void {
  const links = webApp as unknown as TelegramLinks | undefined
  if (links?.openLink) {
    links.openLink(url)
    return
  }
  window.open(url, '_blank', 'noopener')
}

export const haptic = {
  select(): void {
    webApp?.HapticFeedback?.selectionChanged()
  },
  mark(): void {
    webApp?.HapticFeedback?.impactOccurred('light')
  },
  warn(): void {
    webApp?.HapticFeedback?.notificationOccurred('warning')
  },
  fail(): void {
    webApp?.HapticFeedback?.notificationOccurred('error')
  },
  done(): void {
    webApp?.HapticFeedback?.notificationOccurred('success')
  },
}

type TelegramBackButton = {
  BackButton?: {
    show(): void
    hide(): void
    onClick(handler: () => void): void
    offClick(handler: () => void): void
  }
}

const backStack: (() => void)[] = []
let current: (() => void) | undefined

function syncBackButton(): void {
  const button = (webApp as unknown as TelegramBackButton | undefined)?.BackButton
  if (!button) return

  const top = backStack.at(-1)
  if (current) button.offClick(current)
  current = top
  if (top) {
    button.onClick(top)
    button.show()
  } else {
    button.hide()
  }
}

export function pushBackHandler(handler: () => void): () => void {
  backStack.push(handler)
  syncBackButton()

  return () => {
    const index = backStack.lastIndexOf(handler)
    if (index >= 0) backStack.splice(index, 1)
    syncBackButton()
  }
}

export const insideTelegram = Boolean(webApp?.initData)
